import { selectorFamily } from "recoil";
import { stringify } from "query-string";

export const placesState = selectorFamily({
  key: "placesState",
  get:
    ({ limit = 50, ...query }) =>
    async () => {
      const options = {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: process.env.REACT_APP_FSQ_KEY,
        },
      };
      try {
        const response = await fetch(
          `https://api.foursquare.com/v3/places/search?${stringify({
            ...query,
            limit,
          })}`,
          options
        );
        const data = await response.json();
        return data.results.map((place) => ({
          ...place,
          coordinates: [
            place.geocodes.main.longitude,
            place.geocodes.main.latitude,
          ],
        }));
      } catch (error) {
        console.log(error);
        return error;
      }
    },
});
